import React, { useState } from 'react';
import Swal from 'sweetalert2';

import Grid from '@material-ui/core/Grid';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { Button } from '@material-ui/core';

import { sendDateRelationFile } from '../../store/actions';

import { Container, IButton } from '../../../../styles/styles';

import theme from '../../../../styles/theme';

const ProductRelationshipDate: React.FC = () => {
  const [File, setFile] = useState<any>();
  const [MessageResult, setMessageResult] = useState<String>();

  const handleSubmit = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    event.preventDefault();

    if (File) {
      Swal.fire({
        title: 'Aguarde...',
        text: 'Importando Arquivo',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: async () => {
          Swal.showLoading();

          var formData = new FormData();
          formData.append("file", File);
          const response = await sendDateRelationFile(formData);

          if (response.response && response.response.status === 400) {
            setMessageResult(response.response.data.error);
          } else {
            setMessageResult("Arquivo importado com sucesso !");
            setFile(null);
          }

          Swal.close();

        }
      });
    }
  }

  const handleUploadFile = (event: any) => {
    if (event.target.files[0]) {
      setFile(event.target.files[0])
    }
  }

  return (
    <React.Fragment>
      <Container background="#E2E4E6">
        <ValidatorForm onSubmit={(e: any) => handleSubmit(e)}>
          <div style={{ flexDirection: 'row', display: 'flex' }}>
            <div style={{ flex: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <div style={{ marginLeft: 5, marginBottom: 40 }}>
                    <IButton width={170} type="submit" style={{ marginRight: 10 }} onClick={() => { window.location.href = "/files/import-layouts/ManutencaoDataRealacaoProdutos.xlsx" }}>Layout de exemplo</IButton>
                  </div>
                  <div style={{ marginLeft: 10, marginBottom: 10 }}>
                    Selecione o arquivo contendo as informações especificadas no exemplo.
                  </div>
                  <Button
                    variant="contained"
                    component="label"
                    style={{ marginLeft: 10, marginBottom: 10, color: '#666' }}
                    onChange={(e: any) => { handleUploadFile(e) }}
                  >
                    Selecione o arquivo
                    <input
                      type="file"
                      id="uploadFile"
                      accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      style={{ display: "none" }}
                    />
                  </Button>
                  <span style={{ marginLeft: 10, fontWeight: 'bold' }}>{File?.name}</span>
                </Grid>
                <Grid item xs={12} style={{ marginLeft: 10, marginBottom: 40, color: theme.palette.primary.main }}>
                  <b>{MessageResult}</b>
                </Grid>
                <Grid item xs={12}>
                  <IButton width={130} background="#52D126" type="submit" style={{ marginRight: 10 }}>IMPORTAR</IButton>
                </Grid>
              </Grid>
            </div>
            <div style={{ flex: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} style={{ fontSize: 16, color: '#555', marginBottom: 20 }}>
                  <b>Layout do arquivo:</b>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <div style={{ marginBottom: 5 }}>
                  ID Fornecedor <span style={{ color: 'red' }}>*Obrigatório</span>
                </div>
                <div style={{ marginBottom: 5 }}>
                  ID Produto <span style={{ color: 'red' }}>*Obrigatório</span>
                </div>
                <div style={{ marginBottom: 5 }}>
                  Data de Início <span style={{ color: 'red' }}>*Obrigatório</span>
                </div>
                <div style={{ marginBottom: 5 }}>
                  Data de Fim <span style={{ color: 'red' }}>*Obrigatório</span>
                </div>
              </Grid>
            </div>
          </div>
        </ValidatorForm>
      </Container>
    </React.Fragment>
  )
}

export default ProductRelationshipDate;
